import React, { useState, useEffect } from 'react';
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import {styled} from "@mui/system";
import Select from "@mui/material/Select";

const StyledSelect = styled(Select)({
    minWidth: 200,
    maxWidth: '100%',
});
export default function MidiInSelector({ midiInputs, setMidiIn, initialId, setInitialId }) {
    const [selectedMidiInputId, setSelectedMidiInputId] = useState(initialId || "");

    useEffect(() => {
        if (midiInputs.length > 0) {
            if  (midiInputs.find(midi => midi.id === initialId) !== undefined) {
                setSelectedMidiInputId(initialId);
            } else {
                setSelectedMidiInputId(midiInputs[0].id)
            }
        }
    }, [initialId, midiInputs]);
    
    useEffect(() => {
        const input = midiInputs.find(midi => midi.id === selectedMidiInputId);
        if (input) {
            setMidiIn(input);
            setInitialId && setInitialId(selectedMidiInputId);
        }
    }, [midiInputs, selectedMidiInputId, setInitialId, setMidiIn]);
    
    return (
        <FormControl variant="outlined" style={{ marginTop: '10px', width: '100%'  }}>
            <InputLabel id="midi-device-label">MIDI Input Devices</InputLabel>
            <StyledSelect
                labelId="midi-device-label"
                value={selectedMidiInputId}
                onChange={(e) => setSelectedMidiInputId(e.target.value)}
                label="MIDI Input Devices"
            >
                {midiInputs.length === 0 ? (
                    <MenuItem value={""}>出力MIDIデバイスがありません</MenuItem>
                ) : (
                    midiInputs.map((input, index) => (
                        <MenuItem key={index} value={input.id}>
                            {input.name}
                        </MenuItem>
                    ))
                )}
            </StyledSelect>
        </FormControl>
    );
}